export default
function CreatorCredits() {



    return (
        <p className="copyright">
            Copyright © All Rights Reserved by 
            <a
                rel="noreferrer"
                target="_blank" 
                href="https://github.com/veD-tnayrB"
            >
                @BryantDev_
            </a>
        </p>
    )
}